<template>
  <transition
    name="popup-side"
    appear
  >
    <div
      v-if="!toggled"
      class="fixed bottom-0 right-0 z-40 w-full p-5"
      :class="popupData.type !== 'image' ? 'lg:max-w-md' : 'lg:max-w-xl'"
    >
      <div class="flex overflow-hidden rounded-md shadow-lg">
        <div
          v-if="popupData.type === 'image'"
          class="relative w-44"
        >
          <img
            :src="popupData.image"
            class="absolute top-0 left-0 object-cover object-center w-full h-full "
          >
        </div>
        <div class="relative w-full p-5 text-white lg:p-10 bg-brand-500">
          <button
            class="absolute top-0 right-0 m-6 text-2xl transition duration-200 opacity-60 hover:opacity-100"
            @click="close"
          >
            <i class="fal fa-times" />
          </button>
          <p class="lg:text-xl">
            {{ popupData.message }}
          </p>
          <div
            v-if="popupData.action.enable"
            class="mt-5"
          >
            <a
              :href="popupData.action.link"
              class="btn btn-danger"
            >
              {{ popupData.action.label }}
            </a>
          </div>
          <div
            v-if="popupData.type === 'subscribe'"
            class="text-right"
          >
            <img
              :src="imgEnvelope"
              class="inline-block -mt-20 -mb-28 w-28"
            >
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import imgEnvelope from "./img/envelope.png";

export default {
  data() {
    return {
      imgEnvelope,
      popupData: window.popupSide,
      toggled: true,
    };
  },
  mounted() {
    if (this.$cookies.get("popup-side-id")) {
      this.checkLastModified();
    }

    this.$cookies.set("popup-side-id", this.popupData.id);

    if (this.popupData.apply_to_page) {
      this.init();
    }
  },
  methods: {
    init() {
      if (!this.popupData.enable) {
        this.$cookies.remove("popup-side-toggled");
      } else {
        this.showPopup();
      }
    },
    checkLastModified() {
      if (this.$cookies.get("popup-side-id") !== this.popupData.id) {
        this.$cookies.remove("popup-side-toggled");
      }
    },
    close() {
      this.toggled = true;
      this.$cookies.set("popup-side-toggled", true);
    },
    showPopup() {
      if (this.$cookies.get("popup-side-toggled")) {
        this.toggled = true;
      } else {
        setTimeout(() => {
          this.toggled = false;
        }, 1000); // 1000
      }
    },
  },
};
</script>

<style>
.popup-side-enter-active,
.popup-side-leave-active {
  @apply transform transition-all duration-500;
}

.popup-side-enter,
.popup-side-leave-to {
  @apply opacity-0 translate-y-10;
}
</style>
